import React from 'react';
import {useIntl} from 'react-intl';
import ErrorPage from '../../common/ErrorPage/ErrorPage';
import PageTitle from '../PageTitle';
import {useIsDashboardLinkVisible} from './hooks/useIsDashboardLinkVisible';

export function Unauthorized() {
    const intl = useIntl();
    const isDashboardLinkVisible = useIsDashboardLinkVisible();

    const titleKey = 'esl.http.status_401';
    const messageKey = 'esl.error_page.unauthorized_message';

    const customTitleMessage = intl.formatMessage({id: titleKey, defaultMessage: 'Unauthorized Access'});
    const customErrorMessage = intl.formatMessage({id: messageKey, defaultMessage: 'You are not authorized to access this page'});

    return (
        <div>
            <PageTitle pageTitle={customTitleMessage} />
            <ErrorPage
                isDashboardLinkVisible={isDashboardLinkVisible}
                customTitleMessage={customTitleMessage}
                customErrorMessage={customErrorMessage}
            />
        </div>
    );
}
